import fnrvalidator from '@navikt/fnrvalidator';

// Input type IDs
const TEXT                   = 0;
const TEXTAREA               = 1;
const NUMBER                 = 2;
const SELECT                 = 3;
const RADIO                  = 4;
const CHECKBOX               = 5;
const DATE                   = 6;
const FILE                   = 7;
const SOCIAL_SECURITY_NUMBER = 8;
const ZIP_CODE               = 9;
const EMAIL                  = 10;
const PHONE_NUMBER           = 11;
const INFORMATIVE_TEXT       = 12;
const ZIP_CODE_EN            = 13;
const CITIZENSHIP            = 14;
const DATE_OF_BIRTH          = 15;
const CITIZENSHIP_EN         = 16;
const TEXTAREA_LOGIC         = 17;

let isValidDate = function(day, month, year) {

    day = parseInt(day, 10);
    month = parseInt(month, 10);
    year = parseInt(year, 10);

    let currentYear = new Date().getFullYear();
    let minAge = 10;
    let maxAge = 120;

    // Check the ranges of month and year
    if(year < (currentYear-maxAge) || year > (currentYear-minAge) || month == 0 || month > 12)
        return false;

    let monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

    // Adjust for leap years
    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
        monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
};

export function validateInput(applicationForm, input, t){
    const value = applicationForm.input.values[input.id];
    const selectedInputOptions = applicationForm.input.options;
    let result = {
        validated: true,
        error: "",
    }

    // Validate field value
    switch (input.type_id) {
        case TEXT:
        case TEXTAREA:
        case NUMBER:
        case TEXTAREA_LOGIC:
            if(input.required && !value){
                result.validated = false;
                result.error = t('formErrorRequired') + " " + input.name.toLowerCase();
            }
            break;

        case SELECT:
        case RADIO:
        case CHECKBOX:           
            const inputOptions = input.inputoptions.map(option => option.id);
            const intersection = inputOptions.filter(id => selectedInputOptions.includes(id));
            if (input.required && intersection.length === 0) {
                result.validated = false;
                result.error = t('formErrorRequiredAlternative');
            }
            break;

        case DATE:
        case DATE_OF_BIRTH:
            if(input.required && !value){
                result.validated = false;
                result.error = t('formErrorRequiredDate');
            }    

            if (value) {
                const date = value.split("-");
                
                if(date.length < 3){
                    result.validated = false;
                    result.error = t('formErrorDate');
                }

                const day   = date[2];
                const month = date[1];
                const year  = date[0];

                if(!day || isNaN(day) || day < 1 || day > 31){
                    result.validated = false;
                    result.error = t('formErrorDate');
                }
                if(!month || isNaN(month) || month < 1 || month > 12){
                    result.validated = false;
                    result.error = t('formErrorDate');
                }
                if(!year || isNaN(year) || year < 1900 || year > new Date().getFullYear()){
                    result.validated = false;
                    result.error = t('formErrorDate');
                }
            } 
            break;

        case SOCIAL_SECURITY_NUMBER:
            if(input.required && !value){
                result.validated = false;
                result.error = t('formErrorRequiredSocialSecurity');
            }

            if (value) {
                let numValue = value.toString();
                if (numValue.length === 11) {
                    if (fnrvalidator.fnr(numValue).status !== 'valid') {
                        result.validated = false;
                        result.error = t('formErrorRequiredSocialSecurity');
                    }
                } else if (numValue.length === 6) {
                    let day = numValue.substring(0,2);
                    let month = numValue.substring(2,4);
                    let year = parseInt(numValue.substring(4,6), 10);

                    let currentYear = new Date().getFullYear();
                    if (year <= (currentYear-2000)) {
                        year += 2000;
                    }
                    else {
                        year += 1900;
                    }
                    if (!isValidDate(day, month, year)) {
                        result.validated = false;
                        result.error = t('formErrorSocialSecNr');
                    }
                } else {
                    result.validated = false;
                    result.error = t('formErrorSocialSecNr');
                }
            }
            break;

        case ZIP_CODE_EN:
            if(input.required && !value){
                result.validated = false;
                result.error = t('formErrorRequiredZip');
            }

            // International zip codes can have letters, do no numeric validation here
            break;

        case ZIP_CODE:
            if(input.required && !value){
                result.validated = false;
                result.error = t('formErrorRequiredZip');
            }

            if(value){
                const zipData = JSON.parse(value);
                const zipCode = zipData.zipcode?.toString().replace(/\s/g, '');
                if (isNaN(zipCode)) {
                    result.validated = false;
                    result.error = t('formErrorZip');
                }
            }
            break;

        case EMAIL:
            if(input.required && !value){
                result.validated = false;
                result.error = t('formErrorRequired') + " " + input.name.toLowerCase();
            }
        
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (value && !value.match(emailRegex)) {
                result.validated = false;
                result.error = t('formErrorEmail');
            }
            break;

        case PHONE_NUMBER:
            if(input.required && !value){
                result.validated = false;
                result.error = t('formErrorRequired') + " " + input.name.toLowerCase();
            }
            const phoneRegex = /[\+]?[0-9\s\-\(\)]{8,16}/;
            if (value && !phoneRegex.test(value)) {
                result.validated = false;
                result.error = t('formErrorPhone');
            }
            break;

        case CITIZENSHIP:
        case CITIZENSHIP_EN:
            if(input.required && !value){
                result.validated = false;
                result.error = t('formErrorRequiredCountry');
            }
            break;

        case FILE:
            if(input.required && !applicationForm.files.hasOwnProperty(input.id)){
                result.validated = false;
                result.error = t('formErrorRequiredFile');
            }
        default:
            break;
    }
    
    return result;
}